module.exports = __webpack_public_path__ + "static-v-shop/1792141392954/img/landing-mobile-fondo-2.cda3e9f3.png";